module.exports = __webpack_public_path__ + "8859082DD4A154ECB2EBD04ACD88B0FBlogo-2.aa4d0925.png";